import axios from '../../utils/axios';

export default function updateLGBill(adminId, billId, data) {
    return (
        axios.post(`/admin/${adminId}/lGBill/${billId}/update`,  data )
    )
}
